import samEydeVgs from "../../assets/otherImages/Sameyde.vgs.jpg";
import BlogPosts from "../../pages/BlogPost";
import Product from "../../pages/Product";
import ShowCase from "../../pages/ShowCase";
import WhoAreWe from "../../pages/WhoAreWe";
import { Button } from "primereact/button";
import ConsultationBanner from "../ConsultationBanner";
import ContactForm from "../ContactForm";
import FaqPage from "../../pages/Faq";
import FeatureCard from "../FeatureCard";
import StatItem from "../StatItem";
import LinkItem from "../LinkItem";
import { useTranslation } from "react-i18next";

const links = [
  { name: "Open roles", href: "#" },
  { name: "Projects", href: "#" },
  { name: "Our values", href: "#" },
  { name: "Meet our leadership", href: "/aboutUs" },
];

const stats = [
  { name: "Offices ", value: "1" },
  { name: "Dedicated colleagues", value: "4" },
  { name: "Hours per week", value: "25+" },
  { name: "Client Satisfaction", value: "94%" },
];

export default function Example() {
  const { t } = useTranslation();

  const dreamCards = [
    { title: t("dreamsToLife.1h3"), texts: [t("dreamsToLife.1p1"), t("dreamsToLife.1p2")] },
    { title: t("dreamsToLife.2h3"), texts: [t("dreamsToLife.2p1"), t("dreamsToLife.2p2")] },
    { title: t("dreamsToLife.3h3"), texts: [t("dreamsToLife.3p1"), t("dreamsToLife.3p2")] },
    { title: t("dreamsToLife.4h3"), texts: [t("dreamsToLife.4p1"), t("dreamsToLife.4p2")] },
  ];

  return (
    <>
      {/* Основные секции */}
      <WhoAreWe />
      <ShowCase />
      <ConsultationBanner />
      <Product />

      {/* Digital Journey */}
      <section className="relative isolate overflow-hidden bg-gray-900 py-24 sm:py-32 text-center">
        <img
          src={samEydeVgs}
          alt=""
          className="absolute inset-0 -z-10 w-full h-full object-cover object-center opacity-20"
        />
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <h2 className="text-2xl font-semibold text-white sm:text-6xl">{t("digitalJourney.h2")}</h2>
          <p className="mt-8 text-2xl sm:text-xl text-gray-300">{t("digitalJourney.p")}</p>

          <div className="mt-10 max-w-2xl mx-auto lg:max-w-none grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2 md:flex lg:gap-x-10">
            {links.map((link) => (
              <LinkItem key={link.name} {...link} />
            ))}
          </div>

          <dl className="mt-16 grid grid-cols-1 gap-8 sm:mt-20 sm:grid-cols-2 lg:grid-cols-4">
            {stats.map((stat) => (
              <StatItem key={stat.name} {...stat} />
            ))}
          </dl>
        </div>
      </section>

      {/* Dreams to Life */}
      <section className="bg-gradient-to-bl from-blue-200 via-gray-200 to-blue-100 py-12 px-6 md:px-16 lg:px-24">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-5xl font-bold mb-2 text-gray-800">{t("dreamsToLife.title")}</h2>
          <p className="text-gray-600 max-w-3xl mx-auto mb-12">
            {t("dreamsToLife.intro1")}<br />
            {t("dreamsToLife.intro2")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 max-w-6xl mx-auto">
          {dreamCards.map((card, index) => (
            <FeatureCard key={index} {...card} />
          ))}
        </div>
      </section>

      {/* Блог */}
      <BlogPosts />

      {/* Discord Banner */}
      <section className="surface-0 text-700 text-center p-4 sm:p-8 md:p-12 lg:p-20 bg-gradient-to-br from-blue-100 via-blue-200 to-gray-100">
        <div className="text-2xl sm:text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-orange-600 via-blue-400 to-orange-500">
          <i className="pi pi-discord"></i>&nbsp; {t("discordBanner.title1")}
        </div>
        <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold mb-3">{t("discordBanner.title2")}</h2>
        <p className="text-xl sm:text-2xl mb-4 sm:mb-8 mt-4 sm:mt-5 mx-auto w-4/5 sm:w-3/4 md:w-2/3 lg:w-1/2">
          {t("discordBanner.p")}
        </p>
        <a href="https://discord.gg/sBrzuMpt" target="blank">
          <Button
            label="Join Now"
            icon="pi pi-discord"
            className="font-bold px-4 sm:px-5 py-3 p-button-raised p-button-rounded bg-gradient-to-r from-orange-600 via-purple-700 to-orange-500 hover:bg-gradient-to-r hover:from-purple-600 hover:via-orange-700 hover:to-purple-500 transition duration-75"
          />
        </a>
      </section>

      {/* FAQ и Контакты */}
      <FaqPage />
      <ContactForm />
    </>
  );
}